import {
  IContactReferenceCountModel,
  IContactReferenceDataModel,
} from "../interfaces";

export class ContactReferenceDataModel {
  contactTypes: ContactReferenceCountModel[];
  lists: ContactReferenceCountModel[];
  interests: ContactReferenceCountModel[];
  tags: ContactReferenceCountModel[];
  constructor(data?: Partial<ContactReferenceDataModel>) {
    this.contactTypes = data?.contactTypes ?? [];
    this.lists = data?.lists ?? [];
    this.interests = data?.interests ?? [];
    this.tags = data?.tags ?? [];
  }

  static deserialize(
    data: IContactReferenceDataModel
  ): ContactReferenceDataModel {
    return new ContactReferenceDataModel({
      contactTypes: data?.types
        ? data?.types?.map((t) => ContactReferenceCountModel.deserialize(t))
        : [],
      lists: data?.lists
        ? data?.lists?.map((l) => ContactReferenceCountModel.deserialize(l))
        : [],
      interests: data?.interests
        ? data?.interests?.map((i) => ContactReferenceCountModel.deserialize(i))
        : [],
      tags: data?.tags
        ? data?.tags?.map((t) => ContactReferenceCountModel.deserialize(t))
        : [],
    });
  }
}

export class ContactReferenceCountModel {
  count: number;
  name: string;
  contactIds:string[];
  constructor(data?: Partial<ContactReferenceCountModel>) {
    this.count = data?.count ?? 0;
    this.name = data?.name ?? "";
    this.contactIds = data?.contactIds ?? [];
  }
  static deserialize(
    data: IContactReferenceCountModel
  ): ContactReferenceCountModel {
    return new ContactReferenceCountModel({
      count: data.contactIds?.length ?? 0,
      name: data.name ?? "",
      contactIds: data.contactIds ?? [],                
    });
  }
}
